module.exports = __webpack_public_path__ + "assets/videos/covid-hits-home-video-intro-desktop.mp4?v=87eeee2c";